import BaseAPI from "../api";

const path: string = "request-logs";

export interface getLogTypeProps {
  format?:string;
  sortType?: String;
  sortBy?: string;
  page?: number;
  limit?: number;
  endDate?: string;
  startDate?: string;
  idFiscalYear?: number;
}

export class RequestLogApi extends BaseAPI {
  static GetLog(props: getLogTypeProps): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  static download(props: getLogTypeProps): Promise<any> {
    return this.api.get(`${path}/download`, { params: { ...props },responseType: 'arraybuffer' }).then(res => res);
  }
}
